import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'
import InfoIcon from 'components/ReusableComponents/Icons/Info'
import LoadingIndicator from 'components/ReusableComponents/LoadingIndicator'
import InputWithButton from 'components/ReusableComponents/ManageHotel/InputWithButton'
import useCopyText from 'hooks/useCopyText'
import { loyaltyIdNamesByParentChain } from 'main/loyaltyIdNamesByParentChain'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import subscribersApi from 'services/api/subscribers'

import styles from './BonusDialog.module.scss'

const BonusDialog = ({
  onClose,
  onSuccess,
  firstName,
  lastName,
  loyaltyId,
  subscriptionId
}) => {
  const guestname = firstName ? `${firstName} ${lastName}` : 'guest'

  const parentChain = useSelector(s => s.hotelDetails.parentChainCode)

  const loyaltyIdName = loyaltyIdNamesByParentChain[parentChain] || 'Loyalty id'

  const copy = useCopyText()

  const [isApplyingBonus, setIsApplyingBonus] = useState(false)
  const [isErred, setisErred] = useState(false)

  function handleApplyBonus() {
    setIsApplyingBonus(true)

    subscribersApi
      .applyBonus({ subscriberId: subscriptionId })
      .then(() => {
        setisErred(false)
        onSuccess()
      })
      .catch(() => {
        setisErred(true)
      })
      .finally(() => {
        setIsApplyingBonus(false)
      })
  }

  if (isApplyingBonus) {
    return <LoadingIndicator />
  }

  return (
    <ConfirmationDialog
      title={`Apply subscription bonus to ${guestname} `}
      onClose={onClose}
      positiveMessage="I've applied the bonus"
      negativeMessage="Cancel"
      onConfirm={handleApplyBonus}
    >
      <InputWithButton
        className={styles.input}
        label={loyaltyIdName}
        buttonLabel="Copy"
        disabled
        value={loyaltyId}
        buttonProps={{ onClick: () => copy(loyaltyId) }}
      ></InputWithButton>
      <div className={styles.finePrint}>
        <InfoIcon />
        We'll send an text to {guestname} once you confirm
      </div>
      {isErred && <p>Something went wrong</p>}
    </ConfirmationDialog>
  )
}

export default BonusDialog
